const autoNgTemplateLoaderTemplate1 = require('./slider.html');

angular.module('shbdeployer.app').component('slider', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'SliderController',
  bindings: {
    model: '=',
    onChange: '<',
    floor: '<',
    ceil: '<',
    step: '<',
    precision: '<',
  },
});
